import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import UpdateTable from "../../../components/Common/UpdatedTable"
import {
  downloadcashReq,
  downloadDayBook,
  fetchFinanceCashRequirement,
  fetchFinanceJournalEntry,
} from "../../../services/finance/finance"
import moment from "moment"
import JournalEntryFilter from "./filter"
import { Link, useLocation, useNavigate } from "react-router-dom"
import closeIcon from "../../../assets/icons/close.svg"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useDispatch, useSelector } from "react-redux"
import { setFilter } from "../../../store/actions"
import TrashIcon from "../../../assets/icons/iconComponents/trashIcon"

const CashRequirementReport = ({ fromDashboard }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Cash Requirement${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const dispatch = useDispatch()

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error,
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""

  console.log(`desimalrange`, desimalrange)

  const navigate = useNavigate()
  const [search, setSearch] = useState("")
  const [page, setPage] = useState(1)
  const [fetchedData, setFetchedData] = useState()
  const [dateFrom, setDatefrom] = useState("")
  const [dateTo, setDateto] = useState("")
  const [acc, setAcc] = useState("")

  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const [deletedIds, setDeletedIds] = useState([])
  const [deletedAmount, setDeletedAmount] = useState(0)

  const [isDownloading, setIsDownloading] = useState(false)

  console.log(`deletedIds`, deletedIds)

  const toggle = () => setModal(!modal)

  const location = useLocation()
  const [voucherTypeId, setVoucherTypeId] = useState("")
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchFinanceCashRequirement({
        params: `${
          search ? `searchText=${search}` : "searchText"
        }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${
          dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
        }${voucherTypeId ? `&supplier_id=${voucherTypeId}` : ""}${
          dateFrom
            ? `&start_date=${dateFrom}`
            : filters?.dateFrom
            ? `&start_date=${filters?.dateFrom}`
            : ""
        }${
          dateTo
            ? `&end_date=${dateTo}`
            : filters?.dateTo
            ? `&end_date=${filters?.dateTo}`
            : ""
        }`,
      })

      const newData = response?.data || []

      setFetchedData(prev =>
        page > 1 && prev
          ? {
              ...response, // update all fields from latest response
              data: [...(prev.data || []), ...(response.data || [])], // concat old + new data
              total_items: response.total_items, // update counts
              opening_balance: response.opening_balance,
              closing_balance: response.closing_balance,
              total_credit: response.total_credit,
              total_debit: response.total_debit,
              meta: response.meta,
              filter: response.filter,
            }
          : response
      )
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false
    }
    fetchData()
    // setIsLoadingNextPage(responce != undefined ? false : true)
  }, [
    page,
    search,
    location,
    dateFrom,
    dateTo,
    voucherTypeId,
    dataPerPage,
    filters?.dateFrom,
    filters?.dateTo,
  ])
  const handleVoucherTypeChange = id => {
    setVoucherTypeId(id)
    setPage(1)
  }

  const handleDownload = async type => {
    if (isDownloading) return

    try {
      setIsDownloading(true)

      await downloadcashReq({
        params: `download=${type}${
          search ? `&searchText=${search}` : "&searchText"
        }&sortOrder=asc${page ? `&page=${page}` : ""}${
          dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
        }${voucherTypeId ? `&supplier_id=${voucherTypeId}` : ""}${
          dateFrom
            ? `&start_date=${dateFrom}`
            : filters?.dateFrom
            ? `&start_date=${filters?.dateFrom}`
            : ""
        }${
          dateTo
            ? `&end_date=${dateTo}`
            : filters?.dateTo
            ? `&end_date=${filters?.dateTo}`
            : ""
        }`,
        type,
        fileName: type === "pdf" ? "cash_req.pdf" : "cash_req.xlsx",
      })
    } catch (error) {
      console.error("Download failed", error)
    } finally {
      setIsDownloading(false)
    }
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.meta?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [fetchedData, page])

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleDelete = item => {
    const key = item.voucher_id

    // prevent multiple clicks
    if (deletedIds?.includes(key)) return

    // store deleted id
    setDeletedIds(prev => [...prev, key])

    // store deleted amount (for total reduction)
    setDeletedAmount(prev => prev + Number(item.amount || 0))

    // remove from table immediately
    setFetchedData(prev => {
      if (!prev) return prev

      return {
        ...prev,
        data: prev.data.filter(row => row.voucher_id !== key),
      }
    })
  }

  const columns = [
    {
      label: "Name",
      renderCell: item => item?.supplier_name || "-",
    },
    {
      label: <div className="ps-2">Date</div>,
      renderCell: item => (
        <div className="ps-2">
          {moment(item?.transaction_date).format("DD-MMM-YYYY")}
        </div>
      ),
    },
    {
      label: "Voucher No.",
      renderCell: item => (
        <div className="text-link">
          <Link
            to={`/finance-voucher/view/${item?.voucher_id}`}
            onClick={() =>
              dispatch(
                setFilter({
                  dateFrom: dateFrom,
                  dateTo: dateTo,
                })
              )
            }
            className="text-capitalize pointer fw-bold"
          >
            {item?.voucher_no}
          </Link>
        </div>
      ),
    },
    {
      label: "Voucher Type",
      renderCell: item => (
        <div className="">{item?.voucher_type ? item?.voucher_type : "-"}</div>
      ),
    },
    {
      label: "Bill No.",
      renderCell: item => (
        <div className="">{item?.bill_no ? item?.bill_no : "-"}</div>
      ),
    },
    {
      label: "Bill Date",
      renderCell: item => moment(item?.bill_date).format("DD-MMM-YYYY"),
    },
    {
      label: "Description",
      renderCell: item => (
        <div className="text-capitalize">{item?.description}</div>
      ),
    },
    {
      label: <div className="text-end pe-3">Amount (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-3">
          {NumberFormat(Number(item?.amount), desimalrange, desimalrange)}{" "}
          {item?.type === "debit"
            ? "(Dr)"
            : item?.type === "credit"
            ? "(Cr)"
            : ""}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-3">Action</div>,
      renderCell: item => (
        <div className="text-end pe-3">
          <div
            onClick={() => handleDelete(item)}
            style={{
              cursor: "pointer",
              opacity: deletedIds.includes(item.voucher_id) ? 0.4 : 1,
              pointerEvents: deletedIds.includes(item.voucher_id)
                ? "none"
                : "auto",
            }}
          >
            <TrashIcon />
          </div>
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  const handleAccChange = data => {
    setAcc(data)
    setPage(1)
  }
  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <>
                <Breadcrumbs
                  title="Finance"
                  breadcrumbObject={[
                    { title: "Finance", link: "/finance" },
                    { title: "Reports", link: "#" },
                    { title: "Cash Requirement", link: "#" },
                  ]}
                />
              </>
            ) : (
              <></>
            )}
            <>
              <div className="me-2">
                <span
                  id={`PopoverLegacy-1`}
                  className="px-2 mb-3 btn btn-primary"
                >
                  Download
                </span>
              </div>
              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadcashReq({
                        params: `download=pdf${
                          search ? `&searchText=${search}` : "&searchText"
                        }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${
                          dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
                        }${
                          dateFrom
                            ? `&start_date=${dateFrom}`
                            : filters?.dateFrom
                            ? `&start_date=${filters?.dateFrom}`
                            : ""
                        }${
                          voucherTypeId ? `&supplier_id=${voucherTypeId}` : ""
                        }${
                          dateTo
                            ? `&end_date=${dateTo}`
                            : filters?.dateTo
                            ? `&end_date=${filters?.dateTo}`
                            : ""
                        }`,
                        type: "pdf",
                        fileName: `cash_req.pdf`,
                      })
                    }
                  >
                    PDF
                  </div>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadcashReq({
                        params: `download=excel${
                          search ? `&searchText=${search}` : "&searchText"
                        }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${
                          dataPerPage ? `&sizePerPage=${dataPerPage}` : ""
                        }${
                          voucherTypeId ? `&supplier_id=${voucherTypeId}` : ""
                        }${
                          dateFrom
                            ? `&start_date=${dateFrom}`
                            : filters?.dateFrom
                            ? `&start_date=${filters?.dateFrom}`
                            : ""
                        }${
                          dateTo
                            ? `&end_date=${dateTo}`
                            : filters?.dateTo
                            ? `&end_date=${filters?.dateTo}`
                            : ""
                        }`,
                        type: "excel",
                        fileName: `cash_req.xlsx`,
                      })
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover>
            </>
          </div>
          <Card
            className={`me-2 px-2 pb-2 ${
              fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
            }`}
          >
            {!fromDashboard ? (
              <>
                <JournalEntryFilter
                  handleSearchChange={handleSearchChange}
                  handleDateChange={handleDateChange}
                  // handleAccChange={handleAccChange}
                  resetData={{
                    dateFrom: filters?.dateFrom,
                    dateTo: filters?.dateTo,
                  }}
                  isImport={false}
                  handleVoucherTypeChange={handleVoucherTypeChange}
                />
                <hr className="table-divide" />
              </>
            ) : (
              <div></div>
            )}

            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div
                  ref={tableContainerRef}
                  style={{ maxHeight: "450px", overflowY: "auto" }}
                >
                  {fetchedData && (
                    <UpdateTable
                      className="mt-5"
                      nodes={fetchedData?.data}
                      paginate={fetchedData}
                      CurrentPage={page}
                      columns={columns}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="30% 15% 15% 15% 15% 15% 20% 15% 5%"
                      mobileWidth="40% 40% 40% 40% 40% 40%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
                {fetchedData?.data?.length ? (
                  <div className="text-end me-5 pe-5 mt-2">
                    <strong>
                      Total Amount:{" "}
                      {NumberFormat(
                        Number(fetchedData?.total_payable || 0) -
                          Number(deletedAmount || 0),
                        desimalrange,
                        desimalrange
                      )}
                    </strong>
                  </div>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      {/* <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-2">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {viewData?.journal_entry_details && (
                  <UpdateTable
                    className="mt-5"
                    nodes={viewData?.journal_entry_details}
                    // columns={viewColumn}
                    handilpagedrop={false}
                    tableWidth="20% 20% 20% 20% 20%"
                    mobileWidth="40% 40% 40% 40% 40%"
                  />
                )}
              </Col>
            </Row>
          </ModalBody>
        </>
      </Modal> */}
    </React.Fragment>
  )
}

export default CashRequirementReport
